import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Container = styled(Box)(({ theme }) => ({
  'width': '100%',
  'height': '100vh',
  'display': 'flex',
  'flexDirection': 'column',
  'alignItems': 'center',
  'backgroundColor': '#DEEFFB',
  'overflow': 'auto',
  '& .form-container': {
    width: 480,
    height: 'fit-content',
    boxShadow:
      '0px 5px 20px 0px rgba(163, 207, 237, 0.10), 0px 80px 110px -40px rgba(163, 207, 237, 0.47)',
    marginTop: 60,
    marginBottom: 60,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: 0,
    },
  },
}));

export const Actions = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
